import React, { createContext, useContext, useState } from "react";

// ✅ Create a context
const GlobalStateContext = createContext();

// ✅ Create a provider component
export const GlobalStateProvider = ({ children }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [hoveredPoint, setHoveredPoint] = useState(null); // State to track the hovered point
  const [partition1, setPartition1] = useState(false);
  const [jointPoint, setJointPoint] = useState(null); // State to track the hovered point
  const [partition2, setPartition2] = useState(false);
  const [selectedPoint, setSelectedPoint] = useState(null);
  const [draggingLine, setDraggingLine] = useState(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [dragStartPos, setDragStartPos] = useState(null);
  const [portal_rect, setPortal_rect] = useState([]);
  const [zInd, setZind] = useState(10)
  // ✅ Store all states in an object
  const state = {
    dialogOpen, setDialogOpen,
    hoveredPoint, setHoveredPoint,
    partition1, setPartition1,
    partition2, setPartition2,
    jointPoint, setJointPoint,
    selectedPoint, setSelectedPoint,
    draggingLine, setDraggingLine,
    isDrawing, setIsDrawing,
    dragStartPos, setDragStartPos,
    portal_rect, setPortal_rect,
    zInd,setZind
  };

  return (
    <GlobalStateContext.Provider value={state}>
      {children}
    </GlobalStateContext.Provider>
  );
};

// ✅ Custom hook for easy access
export const useGlobalState = () => useContext(GlobalStateContext);
